import { html, LitElement } from 'lit-element';

/**
 * @element rationale-modal-multiple-choice
 * @prop {Object} item - Response
 */
export class RationaleModalMultipleChoice extends LitElement {
  static get properties() {
    return {
      item: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { sessionData, item, correctness } = this.response || {};

    const { choices, keyMode } = item || {};
    const { value } = sessionData || {};

    let valuesToRender = [];
    if (!choices && !value) return '';

    const charCode = keyMode === 'numbers' ? 49 : 65;

    if (!value) {
      // this applies if the choice mode is checkbox
      valuesToRender = (choices || []).reduce((acc, choice) => {
        if (
          (correctness === 'correct' && choice.correct) ||
          (correctness === 'incorrect' && !choice.correct)
        ) {
          acc.push(choices.indexOf(choice));
        }

        return acc;
      }, []);
    } else {
      valuesToRender = (choices || []).reduce((acc, choice, index) => {
        if (value.indexOf(choice.value) >= 0) {
          acc.push(index);
        }

        return acc;
      }, []);
    }

    // <div class="response-value" style="margin-right: 0">
    //   <math-rendering-element .label=${label}></math-rendering-element>
    //   </div>
    //   <div>:</div>

    return html`<div>
      <div class="modal-response-content">
        ${valuesToRender.map(index => {
          const { correct, label, rationale } = choices[index] || {};
          const correctnessClass = correct ? 'correct' : 'incorrect';

          return html`
            <div class="modal-response-content-row">
              <div
                class="header-correct-response-selection ${correctnessClass}"
              >
                ${String.fromCharCode(index + charCode)}
              </div>

              <div class="response-value" style="margin-left: 8px;">
                <math-rendering-element
                  .label=${label}
                ></math-rendering-element>
              </div>
            </div>
            <div class="modal-response-content-row">
              <div class="choice-rationale">
                <div class="choice-rationale-label">R:</div>
                <math-rendering-element
                  .label=${rationale}
                ></math-rendering-element>
              </div>
            </div>
          `;
        })}
      </div>
    </div>`;
  }
}

export default RationaleModalMultipleChoice;
